export const PLAN_LOAD = 'plan/LOAD';
export const PLAN_LOAD_SUCCESS = 'plan/LOAD_SUCCESS';
export const PLAN_LOAD_FAIL = 'plan/LOAD_FAIL';

export const getPlanData = () => async (dispatch, getState, api) => {
  dispatch({ type: PLAN_LOAD });

  try {
    const response = await api.get('/plans');

    if (response.message) {
      dispatch({ type: PLAN_LOAD_FAIL, errorMessage: response.message });
      return;
    }

    dispatch({ type: PLAN_LOAD_SUCCESS, planData: response });
  } catch (error) {
    dispatch({ type: PLAN_LOAD_FAIL, errorMessage: error });
  }
};



// WEBPACK FOOTER //
// ./src/containers/Billing/actions.js